<template>
  <div id="data-list-list-view">
    <!-- searchSheet -->
    <vx-card title="筛选搜索"  noShadow cardBorder collapseAction>
      <vs-row vs-type="flex">
        <vs-col
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-md="6" vs-sm="6" vs-xs="12">
            <span>班级</span>
            <v-select class="width-100" v-model="selectedClass" label="name" :options="classList"/>
        </vs-col>
        <vs-col
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-md="6" vs-sm="6" vs-xs="12">
            <span>课程</span>
            <v-select class="width-100" v-model="selectedCourse" label="name" :options="courseList"/>
        </vs-col>
        <vs-col
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-md="6" vs-sm="6" vs-xs="12">
            <span>学年</span>
            <v-select class="width-100" v-model="selectedYear" label="name" :options="yearList"/>
        </vs-col>
        <vs-col
          vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-md="6" vs-sm="6" vs-xs="12">
            <span>学期</span>
            <v-select class="width-100" v-model="selectedTerm" label="name" :options="termList"/>
        </vs-col>
      </vs-row>
      <div class="vx-row">
        <div class="vx-col w-full mb-base flex justify-end">
          <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="getReportList">搜索</vs-button>
        </div>
      </div>
    </vx-card>

    <!-- learningSituationTable -->
    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="reportList" :hoverFlat="true">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ADD NEW -->
        <!-- <div class="flex">
          <vs-button class="rounded-full px-3 py-2" color="warning" type="border" icon-pack="feather" icon="icon-file" @click="exportData">导出明细</vs-button>
        </div> -->
      </div>
      <template slot="thead">
        <vs-th>序号</vs-th>
        <vs-th sort-key="name">姓名</vs-th>
        <vs-th sort-key="class_name">班级</vs-th>
        <vs-th sort-key="course_name">课程</vs-th>
        <vs-th sort-key="year">学年</vs-th>
        <vs-th sort-key="term">学期</vs-th>
        <vs-th sort-key="learn_hour">学习课时</vs-th>
        <vs-th sort-key="create_num">创建项目</vs-th>
        <vs-th sort-key="publish_num">发布项目</vs-th>
        <vs-th sort-key="final_score">期末成绩</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">{{ indextr + 1 }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
             <vs-td>
              <p>{{ tr.class_name }}</p>
            </vs-td>
             <vs-td>
              <p>{{ tr.course_name }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.year }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.term }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.learn_hour }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.create_num }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.publish_num }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.final_score }}</p>
            </vs-td>
            <vs-td>
              <vs-button class="ml-4" size="small" type="filled" @click="openCommentPopup(tr)">查看评语</vs-button>
              <vs-button class="ml-4" color="warning" size="small" type="filled" @click="openSharePopup(tr)">分享</vs-button>
              <vs-button class="ml-4" color="danger" size="small" type="filled" @click="openDelReportDialog(tr)">删除</vs-button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-popup class="text-center" title="分享二维码" :active.sync="shareActive">
      <p>{{ currentReport.name }}同学{{ currentReport.year }}学年{{ currentReport.term }}「{{ currentReport.course_name }}」课程的学期报告</p>
      <qrcode v-if="shareActive" :value="shareQrcode" :options="{ width: 200 }"></qrcode>
    </vs-popup>
    <vs-popup title="评语" :active.sync="commentActive">
      <p>{{ currentReport.comment }}</p>
    </vs-popup>
    <vs-prompt
      vs-color="danger"
      vs-title="操作确认"
      vs-accept-text="我确定"
      vs-cancel-text="我再想想"
      @vs-accept="delReport"
      :vs-active.sync="delReportPrompt"
    >
      <p>删除该报告后，之前分享的链接将无法访问。你确定要这么做吗？</p>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import VueQrcode from '@chenfengyuan/vue-qrcode'

import config from '@/config'

import { classList } from "@/api/school"
import { courseListByPass } from '@/api/course'
import { getStudentReportList, delStudetnReport } from '@/api/school'

export default {
  components: {
    vSelect,
    'qrcode': VueQrcode,
  },
  data() {
    return {
      classList: [],
      courseList: [],
      yearList: [
        '2021',
        '2022'
      ],
      termList: [
        '上学期',
        '下学期'
      ],
      reportList: [],
      selectedClass: {},
      selectedCourse: {},
      selectedYear: '2021',
      selectedTerm: '上学期',
      itemsPerPage: 20,
      currentReport: {
        name: '',
        final_score: 0,
        comment: ''
      },
      shareQrcode: '',
      shareActive: false,
      commentActive: false,
      delReportPrompt: false,
    }
  },
  created() {},
  mounted() {
    this.isMounted = true;
    this.init();
  },
  computed: {},
  methods: {
    init() {
      classList().then((res) => {
        if (res.code == 1) {
          this.classList = res.data.list
          this.selectedClass = this.classList[0]
        }
      }).catch(() => {})
      courseListByPass().then(res => {
        if (res.code == 1) {
          this.courseList = res.data.list
          this.selectedCourse = this.courseList[0]
        }
      }).catch(() => {})
    },
    getReportList() {
      getStudentReportList({
        class_id: this.selectedClass.id,
        course_id: this.selectedCourse.id,
        year: this.selectedYear,
        term: this.selectedTerm,
        mode: 0
      }).then(res => {
        if (res.code == 1) {
          this.reportList = res.data.list
        }
      }).catch(() => {})
    },
    openDelReportDialog(row) {
      this.currentReport = row
      this.delReportPrompt = true
    },
    delReport() {
      delStudetnReport({
        id: this.currentReport.id
      }).then(res => {
        if (res.code == 1) {
          this.getReportList()
        }
      }).catch(() => {})
    },
    openCommentPopup(row) {
      this.currentReport = row
      this.commentActive = true
    },
    openSharePopup(row) {
      this.currentReport = row
      this.shareQrcode = `${config.shequUrl}/school/report?id=${this.currentReport.id}`
      this.shareActive = true
    }
  }
}
</script>

<style lang="scss" scoped>
#data-list-list-view {
  white-space: nowrap;
}
.width-100{
  width: 100%;
  margin-left: 1rem;
}
.vs-col{
  margin-bottom: 20px;
}
.vs-table--content{
  margin-top: 0;
}
</style>
